import Logo from './Logo.vue';

Logo.install = function(app) {
  app.component(Logo.name, Logo);
};

export default Logo; 